import { useEffect, useRef, useState } from "react";
import { configIMP } from "../ImageMap";
import { Arrow } from "../icons/arrow";
import { useTranslation } from "react-i18next";
import { Filters } from "./filters";
import { formatText } from "../utils/functions";
import Unit from "./unit";
import { Fullscreen } from "../icons/fullscreen";
import { VirtualVisit } from "./visit";

export const Levels = (props) => {
    const { i18n, t } = useTranslation();
    const mapRef = useRef(null);
    // const [currLvl, setCurrLvl] = useState(0);
    const currLvlRef = useRef(0);
    const [tmp, setTmp] = useState(0);
    const [currBG, setCurrBG] = useState("main");
    const [area, setArea] = useState({ min: 0, max: 100 });
    const [openModal, setOpenModal] = useState(false);
    const [currUnit, setCurrUnit] = useState({});

    // console.log(props.data)

    const [activeFilters, setActiveFilters] = useState({ "1.5": true, "3.5": true, "4.5": true, "5.5": true })
    const [areaFilters, setAreaFilters] = useState([0, 100])

    const [currUnits, setCurrUnits] = useState([]);

    function getUnitInfos(unit) {
        var rtn = null;
        rtn = props.data?.find(el => el.unit === parseInt(unit));
        // if (!rtn) { console.warn(unit) }
        return rtn;
    }

    function generateUnitNum(zeLvl) {
        const allUnit = document.querySelectorAll("#image-map-pro .imp-object-poly.imp-object[data-title*='u_']");
        // console.log(allUnit)
        let tmpArray = [];
        let tmpArea = [];
        // setCurrUnits([]);

        allUnit.forEach((el) => {
            const num = el.getAttribute('data-title').substring(2);
            const unitMum = zeLvl + num;
            const text = document.querySelector("#image-map-pro .imp-object-text.imp-object[data-title*='t_" + num + "']")
            // console.log(text)
            if (text) text.innerHTML = unitMum;

            // el.classList.add("numbers")
            // if (zeLvl < 10) {
            //     el.classList.add("small")
            // } else {
            //     el.classList.remove("small")
            // }
            // el.innerHTML = num
            const unit = getUnitInfos(unitMum);

            // tmpArea.push(unit.size);
            tmpArray.push({ ref: el, data: unit });
        })
        // console.log(tmpArea)
        setCurrUnits(tmpArray);
        // setAreaFilters({ min: Math.min(...tmpArea), max: Math.max(...tmpArea) })
    }

    useEffect(() => {
        if (currUnits?.length > 0) {
            const unitTypes = Object.entries(activeFilters).filter(([key, value]) => value).map(([key]) => key)
            const range = { min: formatText(areaFilters[0], area.min, area.max), max: formatText(areaFilters[1], area.min, area.max) };
            currUnits.map(el => {
                if (el?.data) {
                    if (
                        unitTypes.includes(el.data.type) &&
                        el.data.size <= range.max && el.data.size >= range.min
                    ) {
                        // console.log(el.ref.classlist)
                        el.ref.classList.remove("disabled");
                    } else {
                        el.ref.classList.add("disabled");
                    }
                }
            })
        }
    }, [activeFilters, areaFilters, currUnits, area])

    useEffect(() => {
        if (tmp == 1) {
            if (!mapRef.current) return;

            const imp = window.ImageMapPro;
            // console.log(window.ImageMapPro)

            // Exemple d'init
            imp.init(mapRef.current, configIMP);

            imp.subscribe((action) => {
                if (action.type === 'objectClick') {
                    if (action.payload.object.includes("level")) {
                        const num = parseInt(action.payload.object.replace("level_", ""));
                        currLvlRef.current = num;
                        // console.log(num)
                        props.setCurrLvl(num);

                    } else if (action.payload.object.includes("u_")) {
                        const unitNumber = currLvlRef.current + "" + action.payload.object.substring(2);
                        // console.log(props.data)
                        setCurrUnit(props.data.find(el => el.unit.toString() === unitNumber));
                        setOpenModal(true)
                    }
                } else if (action.type === 'artboardChange') {
                    const artboardId = action.payload.artboard;

                    // récupérer toutes les données
                    // console.log(imp.instances[0], imp.instances.LSJ)
                    const state = imp.instances.LSJ.config;

                    // trouver l’artboard correspondant
                    const artboard = state?.artboards?.find(
                        a => a.id === artboardId
                    );
                    const title = artboard?.title;

                    if (title == "Main Floor") {
                        setCurrBG("main")
                        props.setCurrent(el => ({ ...el, sub: "floor" }))
                    } else {
                        props.setCurrent(el => ({ ...el, sub: "unit" }))
                        if (title == "Lvl_02") {
                            setCurrBG("LSJ_lvl_2")
                        } else if (title == "Lvl_03-06") {
                            setCurrBG("LSJ_lvl_3-6")
                        } else if (title == "Lvl_07-09") {
                            setCurrBG("LSJ_lvl_7-9")
                        }

                        const lvl = currLvlRef.current;
                        // console.log(lvl)
                        generateUnitNum(lvl);
                    }

                }
            })
        } else {
            setTmp(1)
        }
    }, [tmp]);

    useEffect(() => {
        if (props.currLvl !== undefined) {
            currLvlRef.current = props.currLvl;
            const imp = window.ImageMapPro;
            if (props.currLvl > 1) {
                let lvl;
                if (props.currLvl == 2) {
                    lvl = "Lvl_02"
                } else if (props.currLvl >= 3 && props.currLvl <= 6) {
                    lvl = "Lvl_03-06"
                } else {
                    lvl = "Lvl_07-09"
                }
                imp.changeArtboard("LSJ", lvl)
                generateUnitNum(props.currLvl)
            } else {
                imp.changeArtboard("LSJ", "Main Floor")
            }
        }
    }, [props.currLvl]);

    useEffect(() => {
        if (currUnits) {
            const minMax = currUnits.map(el => el?.data?.size || 0);
            setArea({ min: Math.min(...minMax), max: Math.max(...minMax) });
        }
    }, [currUnits])

    const toggleFullscreen = () => {
        if (!document.fullscreenElement) {
            const elem = document.documentElement; // Prend tout le document
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) { // Pour Safari
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) { // Pour IE/Edge
                elem.msRequestFullscreen();
            }
        } else {
            // setFullscreen(false)
            document.exitFullscreen();
        }
    };

    return (
        <div className="w-full h-full relative">
            {props.current?.main === "visit" && <VirtualVisit tmpFloorUnit={props.tmpFloorUnit} setIframe={props.setIframe} setCurrent={props.setCurrent} />}
            {currBG !== "main" &&
                <>
                    <div
                        onClick={() => props.setCurrLvl(0)}
                        className="transition-colors z-[3] absolute bg-[var(--gold)] hover:bg-[var(--goldLite)] top-[20px] left-[20px] w-[40px] h-[40px] flex justify-center items-center cursor-pointer"
                    >
                        <Arrow color="white" inversed />
                    </div>
                    <div className="absolute right-[35px] top-[20px] capitalize text-[5vw] lg:text-[65px] text-[var(--gold)] font-[Caslon]">
                        {`${t("floor")} ${props.currLvl.toString().padStart(2, '0')}`}
                    </div>
                    <img className="absolute bottom-[10px] lg:bottom-[180px] w-[70px] lg:w-[150px] right-[60px] lg:right-[20px] pointer-events-none" src="./images/compass_rose.png" />
                </>
            }
            <Filters area={area} hidden={currBG === "main"} currLvl={props.currLvl} setCurrLvl={props.setCurrLvl} currUnits={currUnits} activeFilters={activeFilters} setActiveFilters={setActiveFilters} areaFilters={areaFilters} setAreaFilters={setAreaFilters} />
            <div
                onClick={() => toggleFullscreen()}
                className={`transition-all z-[25] bg-[var(--white)] absolute text-[var(--gold)] border border-[var(--gold)] p-[6px] bottom-[15px] ${(currBG === "main" || props.current?.main === "visit") ? "right-[15px]" : "lg:right-[547px] right-[15px]"} cursor-pointer`}
            >
                <Fullscreen color='inherit' />
            </div>
            <div
                className={`absolute z-[2] pointer-events-none w-full h-full
                        ${currBG === "main" ? `
                            scale-[1.6] translate-x-[30px]
                            md:scale-[1.5] 
                            lg:scale-[1.25]
                            2xl:scale-[1] 2xl:translate-x-0
                        `: "-translate-y-1/2"}
                    `}
                style={{
                    backgroundImage: `url(./images/lsj/${currBG}.png)`,
                    backgroundSize: currBG === "main" ? "100%" : "contain",
                    backgroundPosition: currBG === "main" ? "bottom" : "center",
                    backgroundRepeat: "no-repeat",
                    height: currBG === "main" ? "100%" : "calc(100vh - 100px)",
                    top: currBG === "main" ? "" : "50%",
                    transformOrigin: currBG === "main" ? "bottom center" : "center"
                }}
            ></div>
            <div
                id="image-map-pro"
                className={`
                    ${currBG !== "main" ? "isLevels" : ""} 
                    scale-[1.6] translate-x-[30px]
                    md:scale-[1.5] 
                    lg:scale-[1.25]
                    2xl:scale-[1] 2xl:translate-x-0
                `}
                ref={mapRef}
                style={{
                    transformOrigin: "bottom center"
                }}
            ></div>



            {/* Unit modal */}
            <Unit
                open={openModal}
                onClose={() => setOpenModal(false)}
                currUnit={currUnit}
                imageUrl={"./images/pdf/thumbnails/" + currUnit.pdfName+".webp"}
                pdfUrl={"./images/pdf/pdf/" + currUnit.pdfName+".pdf"}
            />
        </div >
    )
}